module.exports = __webpack_public_path__ + "img/Federale_fr_logo.064643fd.png";